export const ShinGuard = [
  {
    title: "Nike Mercurial Lite Shin Guard",
    desc: "Nike Mercurial Lite Shin Guard ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NKSP2086-876.jpg",
    currency: "INR ",
    price: "1595",
    mrp: "1595",
    discount: "0% off",
  },
  {
    title: "Nike Charge 2.0 Shin Guard",
    desc: "Nike Charge 2.0 Shin Guard ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NKSP2093-836.jpg",
    currency: "INR ",
    price: "1095",
    mrp: "1095",
    discount: "0% off",
  },
  {
    title: "Adidas Everlesto Shin Guard",
    desc: "Adidas Everlesto Shin Guard ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADCW5561.jpg",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
    title: "Adidas X Lesto Shin Guard",
    desc: "Adidas X Lesto Shin Guard ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADCW9716.jpg",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
    title: "Adidas Messi 10 Lesto Football Shin Guard",
    desc: "Adidas Ghost Lesto Football Shin Guard ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADCF0114.jpg",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
    title: "Adidas Ghost Lesto Football Shin Guard",
    desc: "Adidas Ghost Lesto Football Shin Guard ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADBR5366.jpg",
    currency: "INR ",
    price: "999",
    mrp: "799",
    discount: "20% off",
  },
  {
    title: "Nike Protegga Flex Shin Guard (Black/Red)",
    desc: "NIKE Protegga Flex SHIN GUARDS: ULTRA-LIGHTWEIGHT PROTECTION. Including a convenient slip-in sleeve for comfort, the Nike Protegga Flex Soccer Shin Guards have a low-profile for a streamlined fit and mobility. The durable shell is bonded to a dense foam backing for impact absorption. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NKSP0313-451.jpg",
    currency: "INR ",
    price: "1995",
    mrp: "1695",
    discount: "15% off",
  },
  {
    title: "Adidas Ghost Lesto Football Shin Guard",
    desc: "Adidas Ghost Lesto Football Shin Guard ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADBQ8402.jpg",
    currency: "INR ",
    price: "999",
    mrp: "799",
    discount: "20% off",
  },
  {
    title: "Adidas Everlesto Football Shin Guard (White)",
    desc: "Adidas Everlesto Football Shin Guard (White) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAP7036.jpg",
    currency: "INR ",
    price: "799",
    mrp: "639",
    discount: "20% off",
  },
  {
    title: "Nike Protegga Flex Shin Guard (Green)",
    desc: "NIKE Protegga Flex SHIN GUARDS: ULTRA-LIGHTWEIGHT PROTECTION. Including a convenient slip-in sleeve for comfort, the Nike Protegga Flex Soccer Shin Guards have a low-profile for a streamlined fit and mobility. The durable shell is bonded to a dense foam backing for impact absorption. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NKSP0313-300L.jpg",
    currency: "INR ",
    price: "1995",
    mrp: "1995",
    discount: "0% off",
  },
  {
    title: "Nike Protegga Flex Shin Guard (White)",
    desc: "NIKE Protegga Flex SHIN GUARDS: ULTRA-LIGHTWEIGHT PROTECTION. Including a convenient slip-in sleeve for comfort, the Nike Protegga Flex Soccer Shin Guards have a low-profile for a streamlined fit and mobility. The durable shell is bonded to a dense foam backing for impact absorption. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NKSP0313-104L.jpg",
    currency: "INR ",
    price: "1995",
    mrp: "1995",
    discount: "0% off",
  },
  {
    title: "Nike Charge 2.0 Shin Guard (Black/Orange)",
    desc: "NIKE Charge 2.0 SHIN GUARDS: ULTRA-LIGHTWEIGHT PROTECTION. Including a convenient slip-in sleeve for comfort, the Nike Charge 2.0 Soccer Shin Guards have a low-profile for a streamlined fit and mobility. The durable shell is bonded to a dense foam backing for impact absorption. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NKSP2093-451L.jpg",
    currency: "INR ",
    price: "1095",
    mrp: "1095",
    discount: "0% off",
  },
  {
    title: "Nike Charge 2.0 Shin Guard (Black)",
    desc: "NIKE Charge 2.0 SHIN GUARDS: ULTRA-LIGHTWEIGHT PROTECTION. Including a convenient slip-in sleeve for comfort, the Nike Charge 2.0 Soccer Shin Guards have a low-profile for a streamlined fit and mobility. The durable shell is bonded to a dense foam backing for impact absorption. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NKSP2093-010L.jpg",
    currency: "INR ",
    price: "1095",
    mrp: "1095",
    discount: "0% off",
  },
  {
    title: "Adidas Predator Lesto Shin Guard (Yellow/Dark Grey)",
    desc: "Perfect for the game of soccer, adidas Predator Lesto unisex Shin Guard. Crafted with Flexible Light Shield which allows no performance interference through lightweight shield with ideal fit to the leg, the EVA backing offers soft and durable cushioning at the back. Soft Synthetic lining extends high comfort when you play hard on the ground. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADM38663L.jpg",
    currency: "INR ",
    price: "799",
    mrp: "559",
    discount: "30% off",
  },
  {
    title: "Adidas Predator Lite Shin Guard (Yellow/Dark Grey)",
    desc: "Perfect for the game of soccer, adidas Predator Lite unisex Shin Guard. Crafted with Flexible Light Shield which allows no performance interference through lightweight shield with ideal fit to the leg, the EVA backing offers soft and durable cushioning at the back. Soft Synthetic lining extends high comfort when you play hard on the ground. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADM38661L.jpg",
    currency: "INR ",
    price: "1099",
    mrp: "769",
    discount: "30% off",
  },
  {
    title: "Adidas F50 Lite Shin Guard (Solred/White/Black)",
    desc: "Adidas F50 Lite Shin Guard (Solred/White/Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADM38651L.jpg",
    currency: "INR ",
    price: "1099",
    mrp: "1099",
    discount: "0% off",
  },
  {
    title: "UHLSport Lite Pro Football Shin Guards",
    desc: "UHLSport Lite Pro Shin Guards Colour: White/Cyan/Blue. With ankle Support ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/UHLFBSGLTL.jpg",
    currency: "INR ",
    price: "399",
    mrp: "339",
    discount: "15% off",
  },
  {
    title: "UHLSport Tri Safe Air Football Shin Guards",
    desc: "UHLSport Tri Safe Air Shin Guards Colour: Black/Red ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/UHLFBSGTRIL.jpg",
    currency: "INR ",
    price: "499",
    mrp: "399",
    discount: "20% off",
  },
  {
    title: "Nivia Performance Football Shin Guards",
    desc: "Performance Shin Guards are ofÂ Hard Shell. They areÂ Strapless , colour black and available in 2 sizes - Large and Medium ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/performance_m.jpg",
    currency: "INR ",
    price: "180",
    mrp: "139.65",
    discount: "22% off",
  },
  {
    title: "Nike Manchester United Mercurial Lite Shin Guard",
    desc: "NIKE Manchester United Mercurial Lite Shin GuardS: ULTRA-LIGHTWEIGHT PROTECTION. Including a convenient slip-in sleeve for comfort, the Nike Manchester United Soccer Shin Guards have a low-profile for a streamlined fit and mobility. The durable shell is bonded to a dense foam backing for impact absorption. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NKFBSP0278601L.jpg",
    currency: "INR ",
    price: "1295",
    mrp: "1295",
    discount: "0% off",
  },
];
